import { useEffect } from 'react';

/**
 * While `active`, confirm before the page unloads and before in-app link
 * clicks leave the current route. Modified clicks (new tab) are ignored.
 */
export default function useLeaveGuard(active, message) {
  useEffect(() => {
    if (!active) return undefined;

    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const link = e.target.closest?.('a[href^="/"]:not([target])');
      if (!link) return;
      if (!window.confirm(message)) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener('beforeunload', onBeforeUnload);
    document.addEventListener('click', onClick, true);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      document.removeEventListener('click', onClick, true);
    };
  }, [active, message]);
}
